import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';
import { sortAB, sortBA, sortDate } from 'utils/sortTable';

import { Icon, TooltipForElement, BtnDel } from '../Elements';

import tableConfig from './helpers/tableConfig';

import classes from './TableDeleteOption.module.scss';

const TableDeleteOption = ({
  dataDelRelease,
  icon = 'Icn_Delete',
  clickIconRow,
  isDeletable,
  showAllList = true,
  onRatio,
  className
}) => {
  const language = useUserState().user.language;

  const [field, setField] = useState('date');
  const [direction, setDirection] = useState(-1);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData(dataDelRelease);
  }, [dataDelRelease]);

  const handleField = checkedField => {
    const cheked = tableConfig.find(item => item.field === checkedField);

    if (!cheked.isSortable) {
      return;
    }

    if (cheked.field !== field) {
      setField(cheked.field);

      if (cheked.field === 'date') {
        setTableData(
          sortDate(tableData, checkedField, direction, sortAB, cheked.field)
        );
      } else {
        setTableData(sortAB(tableData, checkedField, direction));
      }
    } else if (cheked.field === field) {
      setDirection(direction * -1);

      if (cheked.field === 'date') {
        setTableData(
          sortDate(tableData, checkedField, direction, sortBA, cheked.field)
        );
      } else {
        setTableData(sortBA(tableData, checkedField, direction));
      }
    }
  };

  const TableBody = (article, index) => {
    return (
      <tr className={classes.row} key={article.id}>
        <td className={classes.cell}>
          <span className={cn(isDeletable && classes.indexHover)}>
            {index + 1}
          </span>
          {isDeletable && (
            <TooltipForElement text={t('tooltip', 'RETURN_OPTIONS', language)}>
              <BtnDel
                onClick={() => clickIconRow(article.id, article.pressReleaseId)}
                className={classes.visibilityDeleteHover}
                icon={icon}
              />
            </TooltipForElement>
          )}
        </td>
        <td className={cn(classes.cell, classes.wrapName)}>
          <span className={classes.hiddenTextTwo}>{article.title}</span>
        </td>
        <td className={classes.cell}>
          <button
            type="button"
            className={cn(classes.openRatioButton, classes.wrapTitle)}
            onClick={() => {
              onRatio(index);
            }}
          >
            <span className={cn(classes.link, classes.hiddenTextTwo)}>
              {article.articleTitle}
            </span>
          </button>
        </td>
        <td className={classes.cell}>
          <div className={classes.wrapDate}>
            <p className={classes.date}>{article.createdDate}</p>
            {isDeletable && (
              <BtnDel
                onClick={() => clickIconRow(article.id, article.pressReleaseId)}
                className={classes.visibilityDeleteMobile}
                icon={icon}
              />
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <table className={cn(classes.tableDeleteOption, className)}>
      <thead>
        <tr className={classes.heading}>
          {tableConfig.map(item => (
            <th className={classes.base} key={item.field}>
              <button
                type="button"
                className={cn(
                  classes.directionButton,
                  item.isSortable && classes.directionButton_isSortable
                )}
                onClick={() => handleField(item.field)}
              >
                {item.field === field && (
                  <Icon
                    icon={'Arrow-sort'}
                    className={cn(
                      classes.iconArrowSort,
                      direction === 1 && classes.transformIcon
                    )}
                  />
                )}
                {t('table', item.name, language)}
              </button>
              {item.info && (
                <button type="button" className={classes.infoButton}>
                  <Icon
                    icon={'error_outline-24px-2'}
                    className={classes.iconInfo}
                  />
                </button>
              )}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {tableData.map((article, index) =>
          !showAllList
            ? index < 4 && TableBody(article, index)
            : TableBody(article, index)
        )}
      </tbody>
    </table>
  );
};

TableDeleteOption.propTypes = {
  dataDelRelease: PropTypes.array,
  icon: PropTypes.string,
  clickIconRow: PropTypes.func.isRequired,
  isDeletable: PropTypes.bool,
  showAllList: PropTypes.bool,
  onRatio: PropTypes.func,
  className: PropTypes.string
};

export default TableDeleteOption;
